import styled from "styled-components";

const ViewContainer = styled.div<any>`
    height: 91vh; 
    min-height: 75vh;
    padding: 0px 20px 20px 20px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
`;


export default ViewContainer;